export default __webpack_public_path__ + "static/media/Ficha_garbanzo_ZH.28c1d2b7.png";